import en from '@gasbi/localizations/en.json';
import ua from '@gasbi/localizations/ua.json';
import { extendLocale } from '@gasbi/shared/common/utils';

import overridesEn from './__mocks__/en.json';
import overridesUa from './__mocks__/ua.json';

export const LOCALE_NS = 'distributionAdmin';

export const locales = {
  ua: { [LOCALE_NS]: extendLocale(ua, overridesUa) },
  en: { [LOCALE_NS]: extendLocale(en, overridesEn) },
};

const lng = 'ua';
const supportedLangs = ['ua', 'en'];
const fallbackLng = 'en';
const defaultNS = LOCALE_NS;

export const i18nInstanceOptions = {
  locales,
  lng,
  supportedLangs,
  fallbackLng,
  defaultNS,
};
